import { authAPIUrls } from "../common/apiActions";
import { fetch as http } from "./http";
import OneSignal from "react-onesignal";

export const loginService = async (payload: any) => {
  let deviceToken = await OneSignal.User.PushSubscription.id;
  try {
    const data = await http.Post(authAPIUrls?.login, {
      ...payload,
      device_token: deviceToken,
      email: payload?.username as any,
    });
    console.log("device_token", deviceToken);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  } finally {
    payload?.callback && payload?.callback();
  }
};

export const sendOtpService = async (payload: any) => {
  try {
    const data = await http.Post(authAPIUrls?.sendOtp, {
      ...payload,
    });
    return data;
  } catch (error: any) {
    return error;
  } finally {
    payload?.callback && payload?.callback();
  }
};

export const submitOtpService = async (payload: any) => {
  try {
    const data = await http.Post(authAPIUrls?.submitOtp, {
      ...payload,
    });
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  } finally {
    payload?.callback && payload?.callback();
  }
};

export const changePasswordService = async (payload: any) => {
  try {
    const data = await http.Post(authAPIUrls?.changePassword, {
      ...payload,
    });
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  } finally {
    payload?.callback && payload?.callback();
  }
};

const amadeusBaseUrl = process.env.REACT_APP_AMADEUS_BASE_URL;
const envEnums: any = {
  Developement: "dev",
  Staging: "staging",
  Production: "prod",
};
const currentEnv = envEnums[process.env.REACT_APP_ENV || "prod"];
export const getAmadeusTokenService = async () => {
  if (
    origin === "http://localhost:5173" ||
    origin === "http://192.168.18.128:5173"
  ) {
    const payload = {
      client_id: process.env.REACT_APP_AMADEUS_CLIENT_ID,
      client_secret: process.env.REACT_APP_AMADEUS_CLIENT_SECRET,
    };
    try {
      const data = await http.Postx_www_form(
        `/v1/security/oauth2/token`,
        `grant_type=client_credentials&client_id=${payload?.client_id}&client_secret=${payload?.client_secret}`,
        amadeusBaseUrl,
      );
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  } else {
    try {
      const data = await http.Post(
        `api/token.${currentEnv}.php`,
        { base: process.env.REACT_APP_AMADEUS_BASE_URL },
        "multipart/form-data",
        undefined,
        "/",
      );
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
};

export const fetchUserPermissionsService = async (payload: any) => {
  try {
    let deviceToken = await OneSignal.User.PushSubscription.id;
    if (deviceToken) {
      deviceToken = "/" + deviceToken;
    } else {
      deviceToken = "";
    }
    const data = await http.Get(
      `${authAPIUrls?.userPermissions}${deviceToken}`,
    );
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  }
};

export const logoutService = async (payload?: any) => {
  return new Promise((resolve, reject) => {
    try {
      // Get auth token from persisted localStorage or fallback methods
      let authToken = "";

      // Check for persisted redux state first
      const persistedAuth = localStorage.getItem("persist:root");
      if (persistedAuth) {
        try {
          const parsedAuth = JSON.parse(persistedAuth);
          // Token is under authUser property, double-stringified
          if (parsedAuth.authUser) {
            const parsedAuthUser = JSON.parse(parsedAuth.authUser);
            if (parsedAuthUser.token) {
              authToken = parsedAuthUser.token.replace(/"/g, ""); // Remove extra quotes
            }
          }
        } catch (e) {
          console.log("Error parsing persisted auth:", e);
        }
      }

      // Fallback to other localStorage keys
      if (!authToken) {
        authToken =
          localStorage.getItem("authToken") ||
          localStorage.getItem("token") ||
          "";
      }

      console.log("Logout API Request:", {
        endpoint: authAPIUrls?.logout,
        url: `${process.env.REACT_APP_BASE_URL}/api${authAPIUrls?.logout}`,
        hasAuthToken: !!authToken,
        authTokenPreview: authToken
          ? `${authToken.substring(0, 30)}...`
          : "NO TOKEN",
        timestamp: new Date().toISOString(),
      });

      // Create XMLHttpRequest as per your specification
      const xhr = new XMLHttpRequest();
      // REMOVED: xhr.withCredentials to fix CORS error

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          console.log("Logout API Response:", {
            status: this.status,
            response: this.responseText,
            timestamp: new Date().toISOString(),
          });

          if (this.status >= 200 && this.status < 300) {
            try {
              const data = this.responseText
                ? JSON.parse(this.responseText)
                : { success: true };
              resolve(data);
            } catch (e) {
              resolve({ success: true, message: this.responseText });
            }
          } else {
            console.error("Logout API Error:", {
              status: this.status,
              response: this.responseText,
              timestamp: new Date().toISOString(),
            });
            // Don't reject on logout errors, still resolve to allow cleanup
            resolve({
              success: false,
              error: this.responseText || `HTTP ${this.status}`,
            });
          }
        }
      });

      const fullUrl = `${process.env.REACT_APP_BASE_URL}/api${authAPIUrls?.logout}`;
      xhr.open("POST", fullUrl);

      // Set Authorization header with Bearer token
      if (authToken) {
        xhr.setRequestHeader("Authorization", `Bearer ${authToken}`);
      }

      xhr.setRequestHeader("Content-Type", "application/json");

      // Prepare payload with authToken
      const logoutPayload = {
        authToken: authToken,
        ...payload,
      };

      console.log("Logout payload being sent:", {
        payload: logoutPayload,
        authTokenInPayload: !!authToken,
      });

      // Send request with payload containing authToken
      xhr.send(JSON.stringify(logoutPayload));
    } catch (error: any) {
      console.error("Logout Service Error:", {
        error: error?.message || error,
        timestamp: new Date().toISOString(),
      });
      // Don't reject on logout errors, still resolve to allow cleanup
      resolve({ success: false, error: error?.message || error });
    } finally {
      payload?.callback && payload?.callback();
    }
  });
};
